module.exports = __webpack_public_path__ + "img/chart.cadaf3ee.gif";